// Slices
import adminReducer from './admin/slice'
import affiliateCenterReducer from './affiliate-center/slice'
import authSlice from './auth/slice'
import cabifyProcessSlice from './manage-cabify-process/slice'
import companySlice from './companies/slice'
import compensationReducer from './compensation/compensationSlice'
import countrySlice from './countries/slice'
import currencySlice from './currencies/slice'
import depositsSlice from './deposits/slice'
import footprintSlice from './footprint/footprintSlice'
import messagesSlice from './messages/slice'
import myIntegrationSlice from './developers/slice'
import myOrdersSlice from './myOrders/slice'
import offerSlice from './offers/slice'
import offsetReasons from './offset-reasons/slice'
import projectOptions from './project-options/slice'
import projectSlice from './projects/slice'
import saleOffersSlice from './sale-offers/slice'
import salesSlice from './sales/slice'
import sdgCompliancesSlice from './sdg-compliances/slice'
import stockAlertsSlice from './stock-alert/slice'
import summarySlice from './summary/summarySlice'
import transactionSlice from './transactions/slice'
import userReducer from './users/slice'
import visitorSlice from './visitors/slice'
import voucherSlice from './vouchers/slice'

export const slices = {
  adminReducer,
  affiliateCenterReducer,
  authSlice,
  cabifyProcessSlice,
  companySlice,
  compensationReducer,
  countrySlice,
  currencySlice,
  depositsSlice,
  footprintSlice,
  messagesSlice,
  myIntegrationSlice,
  myOrdersSlice,
  offerSlice,
  offsetReasons,
  projectOptions,
  projectSlice,
  saleOffersSlice,
  salesSlice,
  sdgCompliancesSlice,
  stockAlertsSlice,
  summarySlice,
  transactionSlice,
  userReducer,
  visitorSlice,
  voucherSlice
}

// Publications
export { getPublicationsAPI } from './publications/api'

// Vouchers
export {
  getCampaings,
  createCampaing,
  createDiscountVoucher
} from './vouchers/actions'

export {
  resetCampaignsState,
  resetCreateCampaignsState,
  resetCreateDiscountVoucherState
} from './vouchers/slice-reducers'

export {
  campaingsStateSelector,
  createCampaingStateSelector,
  createDiscountVoucherSelector
} from './vouchers/selectors'

// Header
export { getHeaderData } from './header/api'
// Offset Reasons

export { getOffsetReasonList } from './offset-reasons/actions'

export { offsetReasonListSelector } from './offset-reasons/selectors'

export { resetOffsetReasonListState } from './offset-reasons/slice-reducers'

// Sale Offers

export {
  saleOffersSelector,
  saleOffferFilterProjectSelector,
  userSaleOffersSelector,
  isOffersLoading,
  saleOffferDetailsSelector,
  acceptSaleOffferSelector,
  counterSaleOffferSelector,
  allSaleOffersSelector,
  rejectSaleOffferSelector
} from './sale-offers/selectors'

export {
  resetSalesOfferState,
  resetSalesOfferGroupCreateState,
  resetFilterProjectOfferState,
  resetCreateSaleOfferState,
  resetUserSaleOffersState,
  resetSaleOfferDetailsState,
  resetAcceptSaleOfferState,
  resetCounterSaleOfferState,
  resetAllSalesOfferState,
  updateAdminSaleOfferStatusOnList,
  resetRejectSaleOfferState
} from './sale-offers/slice-reducers'

export {
  getAllSaleOfferGroups,
  getSaleOfferGroups,
  createSaleOfferGroup,
  filterSaleOfferProject,
  createSaleOffer,
  getUserSaleOffers,
  getUserSaleOfferDetails,
  acceptUserSaleOffer,
  makeCounterSaleOffer,
  rejectUserSaleOffer
} from './sale-offers/actions'

// Currencies
export { setCurrency } from './compensation/compensationSlice'

export { fetchCurrencies } from 'src/features/compensation/compensationAPI'

export {
  currencyListSelector,
  loadingCurrenciesSelector
} from './currencies/selectors'

export { getCurrencyListAPI } from './currencies/api'

export { companyDetailsSelector, editCompanySelector } from './companies/state'

/* User States */
export {
  isAdminOrDeveloperState,
  isAdminUserState,
  isPremiumCalculatorUserState,
  isRegisterComplete,
  isWidgetUserState,
  selectUser,
  userAuthenticatedState,
  userCredentials,
  userPersonalData,
  isProjectDeveloperUserState,
  registerBrokerageUserSelector,
  userCanCreateProjectsSelector,
  userCompanyDetailsSelector,
  validateEmailSelector,
  userIsApiPremiumSelector,
  changePasswordSelector,
  userSubscriptionsSelector,
  isForwardProducerSelector
} from './users/selectors'

export { getUserBusinessPurchaseData } from './users/api'

// User Actions
export {
  changePassword,
  changeUserConsent,
  changeUserCurrency,
  changeUserLanguage,
  createUser,
  deleteAuthUser,
  getWidgetUsers,
  updateUserAuthDetails,
  updateUserLoginPersonalData,
  validateUserEmail,
  validateUserEmailForStockSale,
  getUserSubscriptions
} from './users/actions'

/* User Reducers */
export {
  resetChangePasswordState,
  resetUserForm,
  resetUserRegisterState,
  resetUserRegisterSuccessState,
  resetValidateEmailForStockSaleState,
  resetValidateEmailState,
  setUser,
  setUserFormCredentials,
  setUserPersonalDataForm,
  setUserRegisterButtonStepValue,
  resetUserPersonalDataState,
  resetDeleteAuthUserState,
  resetUserSubscriptions
} from './users/slice.reducers'

// Admin Actions
export {
  buildPreviewList,
  createBusinessCertificate,
  getAdminStatics,
  getCalculateData,
  getUsersAdmin,
  validateUser,
  rejectUser,
  getWithdrawals,
  validateWithdrawal,
  getPurchaseDocuments,
  validateCancellationDocument,
  validateReceiptDocument,
  validateTaxReliefDocument,
  validateCarbonForwardFile,
  getAdminTransfers,
  validateTransfer,
  getAdminDeposits,
  cancelWithdrawal,
  initSuppliersInfoAPICron
} from './admin/actions'

export { getFilteredInvoicesAPI } from './admin/api'

// Admin States
export {
  isCarCalculeType,
  isParcelCalculeType,
  isPlaneCalculeType,
  isPurchaseTab,
  purchasePriceCurrency,
  salePriceCurrency,
  selectedBrokerageTab,
  usersAdminSelector,
  usersAdminFilterTextSelector,
  usersAdminFilterTypeSelector,
  usersAdminFilterStatusSelector,
  usersAdminFilterGroupSelector,
  userAdminListFilterSelector,
  validateUserSelector,
  rejectUserSelector,
  withdrawalsSelector,
  withdrawalFilterSelector,
  validateWithdrawalSelector,
  purchaseDocumentsSelector,
  adminStaticsSelector,
  validateCancellationSelector,
  adminTransfersSelector,
  validateAdminTransferSelector,
  validateEmailForStockSaleSelector,
  validateProjectIdForStockSaleSelector,
  createBrokerageOperationSelector,
  adminDepositsSelector,
  brokerageStateSelector,
  cancelWithdrawalSelector,
  suppliersAPICronState
} from './admin/selectors'

// Admin Reducers
export {
  resetAdminUsersState,
  resetDocumentsState,
  resetMassiveCalculationFileData,
  resetMassiveCalculationKeys,
  resetMassiveCalculationState,
  resetTransferState,
  resetValidateCancelationState,
  resetValidateReceiptState,
  resetValidateTaxReliefState,
  resetValidateUserState,
  resetValidateWithdrawalState,
  resetWithdrawalState,
  setAdminUsersFilterGroupOption,
  setAdminUsersFilterStatusOption,
  setAdminUsersFilterTypeOption,
  setAdminUsersTextFilter,
  setBrokeragePurchasePriceCurrency,
  setBrokerageSalePriceCurrency,
  setBrokerageSelectedTag,
  setDocumentsFiltered,
  setDocumentsIsAllCollapse,
  setMassiveCalculationCarKeys,
  setMassiveCalculationExcelData,
  setMassiveCalculationFileName,
  setMassiveCalculationKeys,
  setMassiveCalculationNextButtonDisabled,
  setMassiveCalculationParcelKeys,
  setMassiveCalculationPlaneKeys,
  setMassiveCalculationStep,
  setMassiveCalculationUrl,
  setRejectUserCurrentId,
  setWithdrawalsFilterStatus,
  setWithdrawalsFilterText,
  setTransferFiltered,
  resetValidateTransferState,
  resetRejectTransferState,
  resetAdminDepositsState,
  resetAdminStaticsData,
  resetCancelWithdrawalState,
  resetValidateCarbonForwardFile,
  resetAdminSuppliersState
} from './admin/slice'

// Footprint Actions
export {
  createFootPrint,
  deleteFootPrint,
  getAllFootPrintTypes,
  getFootPrintHistory,
  getFootPrintVsCompensationData,
  getMyFootPrintList,
  updateFootPrint
} from './footprint/actions'

export { resetFootPrintCreateState } from './footprint/footprintSlice'

export {
  footprintTypeSelectors,
  footprintVsCompensationSelector,
  footPrintHistorySelectors,
  myFootprintSelector,
  createFootprintSelector
} from './footprint/selectors'

// My Integrations Actions
export {
  createIntegration,
  getIntegrationChartData,
  getIntegrationPurchasesList,
  getIntegrationStatics,
  getIntegrationProjectsList,
  getAllUserIntegrationsToShareForAccount,
  cleanProjectId,
  addProjectToIntegrations,
  deactivateIntegration,
  getMainIntegrationChartData,
  getUserIntegrationList,
  reactivateIntegration,
  updateIntegrationLogo,
  preparePurchasesForOffset,
  makeOffsetPurchases,
  getAllIntegrationProjects,
  getCreditCardOrders,
  prePurchaseBuyNow,
  getIntegrationOptionalFields,
  getIntegrationWhiteLabelDetails,
  updateIntegrationWhiteLabel,
  recalculateIntegration
} from './developers/actions'

export {
  hasErrorsCreateIntegration,
  currentOffsetStep,
  isOffsetNextButtonDisabled,
  getOffsetByExcelVerifyErrors,
  getOffsetByExcelRequestData,
  allProjectsIntegrationSelector,
  CreateDepositSelector,
  PrePurchaseSelector,
  offsetKeysSelector,
  offsetOptionalFieldsSelector,
  offsetByExcelSelector,
  integrationStaticsSelector,
  offsetByExcelPrepareSelector,
  integrationProjectListSelector,
  offsetByExcelMakePurchasesSelector,
  integrationChartDataSelector,
  integrationPurchasesSelector,
  integrationProjectToShareSelector,
  developersMainChartDataSelector,
  userIntegrationListSelector,
  integrationWhiteLabelSelector,
  createIntegrationSelector,
  reactivateIntegrationSelector
} from './developers/selectors'

export {
  resetAllProjectsIntegration,
  resetCreateDeposit,
  resetCreateIntegrationState,
  resetOffsetByExcelKeysAndExcelData,
  resetOffsetByExcelState,
  resetOffsetPurchases,
  resetPrePurchase,
  resetReactivateIntegrationState,
  resetUpdateLogoState,
  setIntegrationToShareProjectsListFlag,
  setOffsetByExcelKeysAndExcelData,
  setOffsetByExcelKeysSelected,
  setOffsetByExcelStep,
  setOffsetOptionalField,
  setSelectedProjectForPurchase,
  setSelectedVintagetForPurchase,
  setUserIntegrationsFiltered,
  setIntegrationPurchasesFiltered,
  resetWhiteLabelDetails,
  resetIntegrationStaticsState
} from './developers/slice-reducers'

/* Country Actions */
export { getCountriesList } from './countries/actions'

export { getCountryListAPI } from './countries/countriesApi'

export { setCountryListData } from './countries/reducers-slice'

export { countryListSelector } from './countries/selectors'

export { selectCurrencyToken } from './compensation/compensationSlice'

export {
  resetCompanyDetailState,
  resetEditCompanyState
} from './companies/slice-reducers'

export { getCompanyDetails, editCompanyDetails } from './companies/actions'

export { resetCurrencyListState } from './currencies/slice-reducers'

export { getCurrencyList } from './currencies/actions'

// Auth Reducers
export {
  setRegisterStep,
  resetRegisterState,
  setCredentials,
  setRol,
  setPersonalDetails,
  setUserRols,
  resetCreateUserState,
  setUserIsProducer,
  setUserIsWidget,
  setPersonalDetailsFirstName,
  setPersonalDetailsLastName,
  setUserCredentialsEmail,
  setUserCompanyName,
  setUserCountry,
  setUserPhone,
  resetForgotPasswordState,
  resetRestorePasswordState,
  resetLoginState,
  resetVerifyEmailState,
  setUserhasCommercialCommunications,
  setCompleteRegisterFormValue,
  resetCompleteUserInfoSubmitState,
  resetCompleteUserState,
  setVerifyTokenRedirectLogin
} from './auth/slice-reducers'

// Auth Selectors

export {
  verifyEmailSelector,
  completeInfoFormStep,
  completeInfoConfirmSellerRolSelector,
  completeInfoStateSelector,
  completeInfoStatePayloadSelector,
  completeInfoSubmitSelector,
  verifyTokenSelector,
  loginAuthSelector,
  authRolSelector,
  personalDetailsRegisterSelector,
  credentialsRegisterSelector,
  forgotPasswordSelector,
  restorePasswordSelector
} from './auth/selectors'

// Auth States
export {
  selectedRegisterStep,
  userRolsSelector,
  userRolSelector,
  registerUserStateSelector,
  registerUserSelector
} from './auth/state'

// Auth Actions
export {
  registerNewUser,
  requestRestorePassword,
  restorePassword,
  loginUser,
  verifyEmail,
  completeUserInfo,
  verifyToken
} from './auth/actions'

// Summary Action

export {
  summaryBalanceSelector,
  summaryChartFilterSelector,
  summarySalesDataSelector,
  summaryOrdersDataSelector,
  summaryWithdrawSelector,
  summaryDepositSelector
} from './summary/selectors'

export {
  getBalance,
  setFilter,
  getUserSalesData,
  getUserOrdersData,
  createPayPalDeposit,
  createWithdrawPayPal,
  createCreditCardDeposit,
  createBankTransferDeposit
} from './summary/actions'

// Summary Reducers
export {
  resetDepositSuccessState,
  resetDepositPayPalUrlState,
  resetDepositSubmitState,
  resetWithdrawPayPalState
} from './summary/summarySlice'

// Messages Actions, Reducers and Selectors
export {
  resetMessagesList,
  setMessagesFilterText,
  filterMessageByOption,
  filterMessagesByText,
  resetSendMessage,
  resetReadMessage
} from './messages/slice-reducers'

export {
  getUserMessages,
  sendMessage,
  readUserMessage,
  getUserMessagesCount
} from './messages/actions'

export {
  getMessagesSelector,
  filterMessageTextSelector,
  sendMessageSelector,
  readUserMessageSelector,
  getMessageCountSelector
} from './messages/selectors'

// Offers Reducers, actions and Selectors
export {
  getUserOffers,
  expireOffer,
  declineOffer,
  acceptOffer,
  sendRequestForProposal
} from './offers/actions'

export {
  getOffersSelector,
  offersFilterTextSelector,
  declineOfferSelector,
  acceptOfferSelector,
  sendRequestForProposalSelector
} from './offers/selectors'

export {
  setOffersFilterText,
  filterOffersByText,
  filterOffersByOption,
  resetOffersDeclineState,
  resetOffersAcceptState,
  resetRequestForProposalState
} from './offers/slice-reducers'

// Visitors Reducers, actions and selectors
export { checkCookies, trackEvent } from './visitors/actions'

export { cookiesSelector } from './visitors/selectors'

// Deposits Slice, actions, reducers and selectors

export {
  resetDepositsListState,
  setSelectedDeposits,
  setFilteredDeposits,
  setDepositsFilterText,
  resetRemoveDepositsState,
  resetFetchDepositsState,
  resetValidateDepositState,
  resetCancelDepositState
} from './deposits/slice-reducers'

export {
  getDepositsListSelector,
  filteredDepositsSelector,
  selectedDepositsSelector,
  depositListSelector,
  filterDepositTextSelector,
  canExportDepositsSelector,
  canDeleteDepositsSelector,
  removeDepositsSelector,
  completedDepositsSelector,
  fetchDepositSelector,
  validateDepositSelector,
  cancelDepositSelector
} from './deposits/selectors'

export {
  getDepositsList,
  removeDeposits,
  getDepositDetails,
  validateDeposit,
  cancelDeposit
} from './deposits/actions'

// Order Slices, reducers, actions and selectors

export {
  getMyOrdersList,
  getPurchasesFromCertificates,
  getOneOrder,
  getOneOrderAllOrdersItems
} from './myOrders/actions'

export {
  getOrderListSelector,
  filterOrderTextSelector,
  orderListSelector,
  selectedOrdersSelector,
  canExportOrdersSelector,
  ordersCertificatesSelector,
  getOrderCertificatesSelector,
  completedOrdersSelectors,
  allOrdersCertificatesSelector,
  getOneOrderSelector,
  getAllOrderItemsSelector
} from './myOrders/selectors'

export {
  setSelectedOrders,
  setFilteredOrders,
  setFilterOrderText,
  resetMyOrdersState,
  resetOrderCertificatesState,
  resetGetOneOrderState,
  resetGetAllOrderItemsState
} from './myOrders/slice-reducers'

// Sale Slice, reducers, actions and selectors

export {
  resetMySalesList,
  setMySalesSelected,
  setMySalesFiltered,
  setMySalesFilterText,
  resetSaleDetails,
  resetSaleSendDocuments,
  resetSaleDeleteDocuments
} from './sales/slice-reducers'

export {
  salesListSelector,
  selectedSalesSelector,
  oldSaleListSelector,
  saleFilterTextSelector,
  salesFilteredSelector,
  saleDetailsSelector,
  sendSaleDocumentSelector,
  deleteSaleDocumentSelector
} from './sales/selectors'

export {
  getSalesList,
  getSalesDetails,
  sendSaleDocument,
  deleteSaleDocument
} from './sales/actions'

// Transactions Reducers, selectors and actions

export { resetFinalizePaypalPaymentState } from './transactions/slice-reducers'

export { finalizePaypalPaymentSelector } from './transactions/selectors'

export { finalizePaypalPayment } from './transactions/actions'

// Stock Alert Actions, Selectors and Reducers

export {
  resetStockAlertList,
  resetStockAlertDelete,
  resetStockAlertCreate
} from './stock-alert/slice-reducers'

export {
  stockAlertListSelector,
  deleteStockAlertSelector,
  createStockAlertSelector
} from './stock-alert/selectors'

export {
  getStockAlertList,
  deleteStockAlert,
  createStockAlert
} from './stock-alert/actions'

// Sdg Compliances Actions, Reducers and Selectors
export { getSdgCompliancesList } from './sdg-compliances/actions'

export { sdgCompliancesListSelector } from './sdg-compliances/selectors'

export { resetSdgCompliancesListState } from './sdg-compliances/slice-reducers'

// Project Options Actions Reducers and Selectors

export { getProjectOptionList } from './project-options/actions'

export { projectOptionListSelector } from './project-options/selectors'

export { resetProjectOptionsListState } from './project-options/slice-reducers'

// Projects Actions, Reducers and Selectors

export {
  createProject,
  createPurchaseOperation,
  createSaleBrokerageOperation,
  validateProjectId,
  validateProjectIdForStockSale,
  getUserProjects,
  getProjectDetails,
  transferProject,
  createBigProject,
  deleteProjectImage,
  editBigProject,
  deleteProjectDiscount
} from './projects/actions'

export {
  resetBrokerageOperationState,
  resetProjectCreateState,
  resetPurchaseOperationSuccess,
  resetValidateProjectId,
  resetValidateProjectIdForStockSale,
  resetUserProjectsState,
  resetProjectDetailsState,
  resetTransferProjectState,
  resetProjectCreateAllState,
  resetProjectFormState,
  setProjectFormItemValue,
  setProjectFormContentValues,
  setProjectFormTaxDescriptionsValue,
  setDocumentationPayload,
  restFormKindChanged,
  setCertificationFormValues,
  resetCreateBigProjectState,
  setFormDataValues,
  setBillingPayloadForCreate,
  resetEditBigProjectState,
  setUserProjectsFilterText,
  setUserProjectsFilterType
} from './projects/reducers-slice'

export {
  userProjectListSelector,
  userProjectOldListSelector,
  projectDetailsSelector,
  transferProjectSelector,
  createBrokerageProject,
  projectFormCurrentStep,
  projectFormKindSelector,
  projectFormIsActiveSelector,
  projectFormPicturesConvertedSelector,
  selectedContrubutionProjectType,
  isFreeDonationSelectedSelector,
  isContributionUnitSelectedSelector,
  isVintageSelector,
  vintageItemListSelector,
  isVintageFormErrorVisibleSelector,
  projectCurrencyTokenCodeSelected,
  currentVintageSelector,
  isTaxReliefSelector,
  isTaxDescriptionErrorVisibleSelector,
  isPropertyOfClimatetradeSelector,
  projectFormLocationTextSelector,
  projectFormContentImagesSelector,
  documentationFormFilesValues,
  lastStepProjectFormSelector,
  projectFormStateSelector,
  createBigProjectStateSelector,
  isProjectDescriptionErrorVisible,
  editBigProjectStateSelector,
  createBrokerageProjectSelector,
  projectFormPriceSelector,
  isActiveDisabledSelector,
  userProjectListFilterSelector,
  validateProjectIdSelector,
  createPurchaseOperationSelector,
  isAddDiscountDisabledSelector,
  lessVintagePriceSelector
} from './projects/selectors'

export {
  projectFormLocationSelector,
  billingDataSelector,
  formContentSelector,
  priceStockFormValuesSelector,
  taxRefliefInfoValuesSelector,
  certificationFormValues,
  documentationFormValues
} from './projects/big-selectors/projetc-form-values.selector'

export { projectFormPreviewSelector } from './projects/big-selectors/project-preview.selector'

export { projectFormCompletedStepsSelector } from './projects/big-selectors/form.slider.selectors'

export { projectFormSectionHelpers } from './projects/big-selectors/project-form-sections.helpers'

export {
  projectApiPayloadSelector,
  projectApiFilesPayloadSelector,
  projectImagesFilesSelector,
  newProjectImagesFilesSelector
} from './projects/big-selectors/project-api.selectors'

export { isSubmitProjectDisabledSelector } from './projects/big-selectors/project.submit.disabled.selector'

export {
  getFleetSelector,
  getCalculateFootprintSelector,
  fleetFormValue
} from './manage-cabify-process/selectors'

export { resetFileSelector } from './manage-cabify-process/slice-reducers'

export {
  createPushNotificationsAPI,
  getAllNotificationsAPI,
  updateNotificationAPI,
  deleteNotificationAPI
} from './push-notifications/api'
